import { SavedHypotheticalService } from './saved-hypothetical.service';
import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "./saved-hypothetical.service";
export class HypotheticalsFolderableCollectionService extends FolderableCollectionLoadOnScrollServiceBase {
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        const dataParams = formFlattenedObject(this.dataParams, Object.keys(this.dataParams));
        return this.savedHypotheticalService.getFolderableItems(dataParams);
    }
    constructor(savedHypotheticalService) {
        super();
        this.savedHypotheticalService = savedHypotheticalService;
        this.scrollableBodyId = 'hypotheticalsTable';
    }
}
HypotheticalsFolderableCollectionService.ɵfac = function HypotheticalsFolderableCollectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HypotheticalsFolderableCollectionService)(i0.ɵɵinject(i1.SavedHypotheticalService)); };
HypotheticalsFolderableCollectionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HypotheticalsFolderableCollectionService, factory: HypotheticalsFolderableCollectionService.ɵfac });
